export const optionPie = {
    title: {
        text: '票种销量分布',
        // subtext: 'Fake Data',
        // left: 'center'
    },
    tooltip: {
        trigger: 'item'
    },
    legend: {
        show:false
        // orient: 'vertical',
        // top:'5%',
        // left: 'left'
    },
    series: [
        {
            // name: 'Access From',
            type: 'pie',
            radius: '50%',
            data: [
                // { value: 1048, name: 'Search Engine' },
                // { value: 735, name: 'Direct' },
                // { value: 580, name: 'Email' },
                { value: 0, name: '电脑票',itemStyle:{color:'oklch(62.3% .214 259.815)'} },
                { value: 0, name: '即开票',itemStyle:{color:'oklch(70.5% .213 47.604)'} }
            ],
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        }
    ]
};
export const optionLine = {
    grid:{
        width:'100%',
        height:'100%'
    },
    xAxis: {
        type: 'category',
        data: []
    },
    yAxis: {
        type: 'value'
    },
    series: [
        {
            data: [],
            type: 'line'
        }
    ]
};